<template>
  <div class="wrapper">
    <div class="top">
      <div class="logo">
        <img src="@/assets/yy_vpn.png" class="yy-logo">
        <div id="logo_title">YYVPN</div>
        <div id="logo_text">让远程办公更方便(๑•̀ㅂ•́)و✧</div>

        <el-row class="btn-row">
          <el-button type="primary" class="big-btn">
            <a :href="os==='android'?downloadUrl.android.download_url:'itms-services://?action=download-manifest&url=' + downloadUrl.ios.download_url">
              <svg-icon :icon-class="os" class="os-icon"></svg-icon>
              下载{{ myFormatOs(os) }}版
            </a>
          </el-button>
        </el-row>
      </div>
    </div>

    <div v-show="isWeixin" v-bind:class="{ height: weixin.height, display: weixin.display}" class="weixin-tip">
      <p>
        <img src="@/assets/guide.png" alt="在浏览器中打开">
      </p>
    </div>

    <div class="middle">
      <div class="text-other-option" style="margin-top: -48px">
        <el-row class="guide-title">使用指南</el-row>
        <el-row class="guide-content">
          <ul>
            <li>首次外网连接，通过OA手机短信验证码认证</li>
            <li>内网连接成功后，该手机自动认证为员工可信任移动设备</li>
          </ul>
        </el-row>
        <img src="@/assets/remote_work.jpg" class="yy-img">
      </div>

      <div class="footer">
        <p>质量与研发管理部 研发</p>
        <p>联系方式：020-32313300</p>
      </div>
    </div>

  </div>
</template>

<script>
    import { getBrowserOs, formatOS, isWeixin } from "@/utils";
    import { getClientNewestVersion, checkIsInnerIp } from '@/api'

    export default {
        name: "MobileHome",
        data() {
          return {
            os: 'android',
            versionInfo: [],
              downloadUrl: {
              android: {download_url: ''},
              ios: {download_url: ''},
              mac: {download_url: ''},
              windows: {download_url: ''}
            },
            isWeixin: false,
            weixin: {
              height: 0,
              display: 'none'
            }
          }
        },
        created() {
          this.os = getBrowserOs();
          this.fetchClientVersion();

          this.isWeixin = isWeixin() && this.os === 'ios';
          if (this.isWeixin) {
            this.weixin.height = window.height;
          }

        },
        methods: {
          myFormatOs(os) {
            if (os === 'android') {
              return "安卓";
            }
            return formatOS(os);
          },
          fetchClientVersion() {
            getClientNewestVersion().then(resp => {
              if(resp.code === 0)
              {
                // this.versionInfo = resp.data;
                let target_client = null;
                for(var i in resp.data) {
                  switch (resp.data[i].os) {
                    case 'android':
                      this.downloadUrl.android = resp.data[i];
                      break;
                    case 'ios':
                      this.downloadUrl.ios = resp.data[i];
                      break;
                    case 'mac':
                      this.downloadUrl.mac = resp.data[i];
                      break;
                    case 'windows':
                      this.downloadUrl.windows = resp.data[i];
                  }
                  if (resp.data[i].os === this.browserOs) {
                    target_client = resp.data[i];
                    continue
                  }
                  this.versionInfo.push(resp.data[i]);
                }
                if (target_client) {
                  this.versionInfo.unshift(target_client);
                }
                console.log('getClientNewestVersion: ', this.versionInfo);
              }
            });
          },
        }
    }
</script>

<style scoped>
  html, body {
    text-align: center;
  }

  .top {
    background-image: linear-gradient(-180deg, #f4fcff 0%, #21273326 100%);
    border-bottom: 1px solid #E4E4E4;
  }

  .logo {
    margin: 0 auto;
    padding-top: 36px;
    width: 100%;
    text-align: center;
    vertical-align: center;
  }

  .logo .yy-logo {
    width: 30%;
    text-align: center;
    margin-top: 20px;
  }

  #logo_title {
    font-size: 24px;
    color: #666;
    text-align: center;
    margin-top: 20px;
  }

  #logo_text {
    font-size: 20px;
    color: #929292;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 36px;
  }

  /deep/ .el-button--primary {
    background-color: #000;
    border-color: #000;
  }

  .btn-row {
    text-align: center
  }

  .big-btn {
    width: 200px;
    height: 55px;
    background: #000;
    border-radius: 5px;
    text-decoration: none;
    font-size: 1.5em;
    margin-bottom: 80px;
  }

  .text-other-option {
    width: 80%;
    font-weight: normal;
    background-color: #fdfdfd;
    box-shadow: 0px 1px 8px 0px rgba(0,0,0,0.12);
    border-radius: 12px;
    margin: 20px auto;
    /*background-size: 80%;*/
    padding-top: 20px;
    font-size: 13px;
    color: #929292;
    line-height: 16px;
    padding-bottom: 5px;
    margin-top: -48px;
  }

  .middle {
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    bottom: 0;
  }

  .yy-img {
    width: 80%;
  }

  .footer {
    margin-top: 30px;
    margin-bottom: 16px;
    font-size: 12px;
    color: grey;
  }

  .guide-title {
    font-weight: 400;
    font-size: 1.6em;
    text-align: center;
    margin-top: 20px;
    color: #666;
  }

  .guide-content {
    text-align: left;
    margin-right: 10px;
    font-size: 1.1em;
    margin-top: 10px;
  }

  .guide-content ul li+li {
    margin-top: 8px;
  }

  .weixin-tip {
    /*display: none;*/
    position: fixed;
    left:0;
    top:0;
    bottom:0;
    background:rgba(0,0,0,0.8);
    filter:alpha(opacity=80);
    height: 100%;
    width: 100%;
    z-index: 100;
  }

  .weixin-tip p {
    text-align: center;
    margin-top: 10%;
    padding:0 5%;
  }

  .weixin-tip img {
    max-width: 100%;
    height: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/MobileHome.vue